import React from "react";
import "./Conservation.css";
import Footer from "../home-page/Footer";


import img1 from "../../img/belanki.jpeg";
import img2 from "../../img/kuchi.jpg";
import img3 from "../../img/Irali.jpg";
import img4 from "../../img/Agalgaon.jpg";
import img5 from "../../img/fort.jpg";
import img6 from "../../img/chambli.jpg";

const Conservation = () => {
  const conservationProjects = [
    {
      title: "Belanki Mahadev Temple Conservation",
      description: `
        The Belanki Mahadev temple is a fine example of ancient Indian temple architecture. 
        Restoration work includes detailed carving repairs, stone cleaning, and structural reinforcements 
        to ensure the temple remains an enduring testament to our history. Conservation efforts focus 
        on preserving its ornate sculptures and ensuring its significance for future generations.`,
      image: img1,
    },
    {
      title: "Kuchi Mahadev Temple Conservation",
      description: `
        Known for its unique design and cultural prominence, Kuchi Mahadev temple is undergoing a thorough 
        restoration. The project includes repairing its weather-worn facade, restoring the sanctum, and 
        preserving the surrounding pathways to create an inviting and historically authentic experience 
        for visitors and worshippers.`,
      image: img2,
    },
    {
      title: "Irali Mahadev Temple Conservation",
      description: `
        The Irali Mahadev temple is rich in murals and decorative elements. This conservation effort is 
        focused on safeguarding its intricate paintings, stabilizing its foundation, and introducing measures 
        to prevent further erosion from environmental factors. The work ensures the temple’s cultural narrative 
        remains intact.`,
      image: img3,
    },
    {
      title: "Agalgaon Mahadev Conservation",
      description: `
        Agalgaon Mahadev temple has withstood the test of time but requires immediate attention to maintain 
        its structural and aesthetic integrity. Efforts include stone replacement, roof stabilization, and 
        improving access to its surroundings for both pilgrims and researchers.`,
      image: img4,
    },
    {
      title: "Mangalwedha Fort Conservation",
      description: `
        A significant landmark in the region, the Mangalwedha Fort has seen centuries of history unfold. 
        The conservation focuses on strengthening its defensive walls, reviving its ancient gateways, 
        and restoring interior structures to make it a focal point of historical tourism.`,
      image: img5,
    },
    {
      title: "Chambli Mahadev Temple Conservation",
      description: `
        Chambli Mahadev temple is a site of immense spiritual importance. Conservation work includes repairing 
        the damaged sections of the temple, restoring its intricate carvings, and enhancing its surrounding 
        landscape to create a tranquil environment that reflects its heritage.`,
      image: img6,
    },
  ];

  return (
    <div className="conservation-page">
        <h1 className="blog-header">Preserving Our  <span className="highlight-blog">Heritage!</span>   </h1>
      <div className="conservation-container">
        {conservationProjects.map((project, index) => (
          <div className="conservation-section" key={index}>
            <img
              src={project.image}
              alt={project.title}
              className="conservation-image"
            />
            <div className="conservation-text">
              <h2 className="conservation-title">{project.title}</h2>
              <p className="conservation-description">{project.description}</p>
            </div>
          </div>
        ))}
      </div>
      <Footer/>
    </div>
  );
};

export default Conservation;
